var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('px-view-header',{attrs:{"title":"Gestão de entregas","title-class":"font-weight-bold","breadcrumbs":_vm.breadcrumbs}}),_c('div',[_c('px-gestao-entrega-lista')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }